"use strict";

const getComparisonDates = require("./lib/get-comparison-dates");
const getBaseDates = require("./lib/get-base-dates");
const getFormattedLabel = require("./lib/get-formatted-label");
const getOutputDates = require("./lib/get-output-dates");
const getInclusiveEndDate = require("./lib/get-inclusive-end-date");
const getLocaleDates = require("./lib/get-locale-dates");
const getSnappedStartDate = require("./lib/get-snapped-start-date");
const getSnappedEndDate = require("./lib/get-snapped-end-date");
const sanitizeProps = require("./lib/sanitize-props");
const validateProps = require("./lib/validate-props");

const EMPTY_RESULT = {
  startDate: null,
  endDate: null,
  label: null
};

const hasDateProps = ({ startDate, endDate, singleDate, dateDuration }) =>
  [!!startDate, !!startDate && !!endDate, !!dateDuration, !!singleDate].some(
    (condition) => condition
  );

/**
 * Reduces props through a series of processors
 */
const getDateRange = (props) => {
  const sanitizedProps = sanitizeProps(props);

  // Safely return empty result when date input is empty
  if (!hasDateProps(sanitizedProps)) {
    return EMPTY_RESULT;
  }

  // Checks for invalid props
  const errors = validateProps(sanitizedProps);

  if (errors.length) {
    throw new Error(`Date-ranges: ${errors.join(" ")}`);
  }

  return [
    getBaseDates, // Create base dates
    getLocaleDates, // Assign locale
    getSnappedStartDate, // Handle snapping the start-date
    getSnappedEndDate, // Handle snapping the end-date
    getComparisonDates, // Handle transposing to comparison dates
    getFormattedLabel, // Get formatted label
    getInclusiveEndDate, // Handle inclusive end-date
    getOutputDates // Format result as ISO
  ].reduce((result, fn) => fn(result, sanitizedProps), {});
};

module.exports = getDateRange;
